import React, { createContext } from "react";
import ProjectFilePlanReducerAction from "./project-file-plan-reducer-action";
import PlanFileData from "@/pages/takeoff/context/project-measure/models/plan-file-data";
import ProjectOrganisationBuilding from "@/pages/takeoff/context/project-organisation/models/project-organisation-building";
import ProjectOrganisationStorey from "@/pages/takeoff/context/project-organisation/models/project-organisation-storey";
import BaseFileData from "@/pages/takeoff/context/project-organisation/models/base-file-data";
import FragmentRecord from "@/pages/takeoff/context/project-measure/models/fragment-record";


export interface ProjectFilePlanContextProps {
    planFileDataLeft: PlanFileData;
    planFileDataRight: PlanFileData;

    urlFileLeft: string;
    urlFileRight: string | undefined;

    buildingLeft: ProjectOrganisationBuilding | undefined;
    buildingRight: ProjectOrganisationBuilding | undefined;

    storeyLeft: ProjectOrganisationStorey | undefined;
    storeyRight: ProjectOrganisationStorey | undefined;

    fileLeft: BaseFileData | undefined;
    fileRight: BaseFileData | undefined;

    fragsDataLeft: FragmentRecord[] | undefined;
    fragsDataRight: FragmentRecord[] | undefined;

    isDirty: boolean;
    isSaving: boolean;

    setFileIdRight: (id: string | undefined) => void;

    dispatchLeft: React.Dispatch<ProjectFilePlanReducerAction>;
    dispatchRight: React.Dispatch<ProjectFilePlanReducerAction>;

    saveCurrentFileData: () => Promise<boolean>;
}

export const ProjectFilePlanContext = createContext<ProjectFilePlanContextProps | undefined>(undefined);